(function () {
  let swiperLoadAttempts = 0;

  function getSlideCount(carousel) {
    const count = parseInt(carousel.dataset.slideCount || '0', 10);
    if (!Number.isNaN(count) && count > 0) return count;
    return carousel.querySelectorAll('.swiper-slide').length;
  }

  function bindEssentialProductForms() {
    document.querySelectorAll('.essential-products').forEach((section) => {
      if (section.dataset.atcBound === 'true') return;
      section.dataset.atcBound = 'true';

      section.addEventListener('submit', (event) => {
        event.preventDefault();
      });
    });
  }

  function initEssentialProductsCarousels() {
    bindEssentialProductForms();

    if (typeof Swiper === 'undefined') {
      if (swiperLoadAttempts < 40) {
        swiperLoadAttempts += 1;
        window.setTimeout(initEssentialProductsCarousels, 50);
      }
      return;
    }

    document.querySelectorAll('[data-essential-products-carousel]').forEach((carousel) => {
      const paginationEl = carousel.querySelector('.essential-products__pagination');
      const slideCount = getSlideCount(carousel);
      const hasMultipleSlides = slideCount > 1;

      if (carousel.swiper) {
        carousel.swiper.destroy(true, true);
      }

      new Swiper(carousel, {
        slidesPerView: 1,
        spaceBetween: 16,
        watchOverflow: true,
        loop: hasMultipleSlides,
        pagination: hasMultipleSlides
          ? {
              el: paginationEl,
              clickable: true,
            }
          : false,
        autoplay: hasMultipleSlides
          ? {
              delay: 5000,
              disableOnInteraction: false,
              pauseOnMouseEnter: true,
            }
          : false,
      });
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initEssentialProductsCarousels);
  } else {
    initEssentialProductsCarousels();
  }

  document.addEventListener('shopify:section:load', initEssentialProductsCarousels);
})();
